import { render } from "./LoaderAnimation.vue?vue&type=template&id=a1126b80&scoped=true"
import script from "./LoaderAnimation.vue?vue&type=script&lang=js"
export * from "./LoaderAnimation.vue?vue&type=script&lang=js"

import "./LoaderAnimation.vue?vue&type=style&index=0&id=a1126b80&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1126b80"]])

export default __exports__